(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const checkoutButton = document.querySelector('.checkout-button');
  const consentCheckbox = document.querySelector('#consent-chk');

  if (checkoutButton) {
    checkoutButton.addEventListener('click', function(event) {
      if (!consentCheckbox.checked) {
        event.preventDefault();
        alert('購入を続ける前に、規約に同意してください。');
      }
    });
  }
});

  
document.getElementById('consent-text').onclick = function() {
  // 規約テキストをクリックしたときにモーダルを表示
  document.getElementById('termsModal').style.display = 'block';
};


  function closeTermsModal() {
  document.getElementById('termsModal').style.display = 'none';
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-countdown-v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
	document.body.style.display = 'block';
});

  } catch(e) { console.error(e); }
})();
})();
